import {ServerUrls} from '~commonInfra/url/ServerUrls';
import {SolrErrorCode} from '~commonInfra/utils/ErrorCodes';
import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';
import {showRouterError} from '~src/spacesPlatform/actions/RouterErrorActions';

import {LoginUrlsWrapper} from '../authentication/components/loginSpace/LoginUrls';
import {getAppStore} from '../bootstrap/redux/store/AppStore';
import {AuthLevel, getSessionManagementServiceInstance} from '../sessionManagement/SessionManagementService';

export function maybeHandleSearchServerDown(errorCode: number) {
    // extract path portion from fragment and remove leading '#'
    const path = WindowLocationService.getFragmentWithoutQuery().substring(1);

    if (errorCode && errorCode === SolrErrorCode.SolrCommunicationError || errorCode === SolrErrorCode.SolrDisabled) {
        if (!getSessionManagementServiceInstance().isUserAuthorized(AuthLevel.ServerAdmin)) {
            LoginUrlsWrapper.navigateToSignInErrorCode('' + errorCode);
        } else if (path !== ServerUrls.getInstance().statusPath()) {
            getAppStore().dispatch(showRouterError('search-server-down'));
        }
        return true;
    } else {
        return false;
    }
}
